import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

export function PageHero({ overline, title, intro, breadcrumb = [], image }) {
  return (
    <section className="relative border-b border-border overflow-hidden grain" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover opacity-20 grayscale" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/60 to-background" />
        </>
      )}
      <div className="absolute inset-0 blueprint-grid opacity-40" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 pt-32 pb-16 lg:pt-40 lg:pb-20">
        {breadcrumb.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-6 flex items-center gap-2 font-mono-tech text-[11px] tracking-widest uppercase text-muted-foreground">
            {breadcrumb.map((b, i) => (
              <span key={b.path} className="flex items-center gap-2">
                {i > 0 && <CaretRight size={11} />}
                {i < breadcrumb.length - 1 ? (
                  <Link to={b.path} className="hover:text-primary transition-colors">
                    {b.name}
                  </Link>
                ) : (
                  <span className="text-primary">{b.name}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <Reveal className="font-mono-tech text-xs sm:text-sm tracking-widest uppercase text-primary mb-4 flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-primary" /> {overline}
        </Reveal>
        <Reveal as="h1" delay={80} className="font-display uppercase tracking-tight text-4xl sm:text-6xl lg:text-7xl leading-[0.9] max-w-4xl text-balance">
          {title}
        </Reveal>
        {intro && (
          <Reveal delay={150} className="mt-6 max-w-2xl text-muted-foreground text-base sm:text-lg leading-relaxed">
            {intro}
          </Reveal>
        )}
      </div>
    </section>
  );
}
